import { YouTube } from "$components";
import Image from "../../../../content/articles/2019-07-15-serverless-og-image/image";
import React from 'react';
export default {
  YouTube,
  Image,
  React
};